import * as ActivityTeaching from './activityTeaching.js';
export default ActivityTeaching;
